import styled from 'styled-components'

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 10050;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(23, 23, 23, 0.58);
  backdrop-filter: blur(5px);
`

export const Dialog = styled.div`
  position: relative;
  width: min(460px, 100%);
  padding: 28px;
  border: 1px solid rgba(224, 0, 0, 0.1);
  border-radius: 22px;
  background: #fff;
  box-shadow: 0 28px 80px rgba(0, 0, 0, 0.24);
`

export const CloseButton = styled.button`
  position: absolute;
  top: 14px;
  right: 14px;
  width: 34px;
  height: 34px;
  border: 0;
  border-radius: 50%;
  background: #f5f5f5;
  color: #777;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  svg {
    width: 18px;
    height: 18px;
  }

  &:hover:not(:disabled) {
    background: #eeeeee;
    color: #333;
  }

  &:disabled {
    cursor: wait;
    opacity: 0.55;
  }
`

export const IconWrap = styled.div`
  width: 52px;
  height: 52px;
  margin-bottom: 18px;
  border-radius: 16px;
  background: #fff1f1;
  color: #d80000;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 24px;
    height: 24px;
  }
`

export const Content = styled.div`
  padding-right: 18px;
`

export const Eyebrow = styled.div`
  margin-bottom: 4px;
  color: #d80000;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
`

export const Title = styled.h2`
  margin: 0;
  color: #202020;
  font-size: 24px;
  font-weight: 800;
  line-height: 1.15;
`

export const Description = styled.div`
  margin-top: 10px;
  color: #686868;
  font-size: 13px;
  line-height: 1.6;

  strong {
    color: #292929;
  }
`

export const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 24px;

  @media (max-width: 520px) {
    flex-direction: column-reverse;
  }
`

const ActionButton = styled.button`
  min-height: 42px;
  padding: 0 18px;
  border-radius: 999px;
  font-family: inherit;
  font-size: 12px;
  font-weight: 800;
  cursor: pointer;
  transition:
    transform 160ms ease,
    box-shadow 160ms ease,
    background 160ms ease,
    border-color 160ms ease;

  &:hover:not(:disabled) {
    transform: translateY(-1px);
  }

  &:disabled {
    cursor: wait;
    opacity: 0.65;
  }

  @media (max-width: 520px) {
    width: 100%;
  }
`

export const CancelButton = styled(ActionButton)`
  border: 1px solid #dedede;
  background: #fff;
  color: #555;

  &:hover:not(:disabled) {
    background: #f7f7f7;
    border-color: #c9c9c9;
  }
`

export const ConfirmButton = styled(ActionButton)`
  border: 1px solid #d80000;
  background: #d80000;
  color: #fff;
  box-shadow: 0 8px 20px rgba(216, 0, 0, 0.18);

  &:hover:not(:disabled) {
    background: #bf0000;
    border-color: #bf0000;
    box-shadow: 0 10px 24px rgba(191, 0, 0, 0.24);
  }
`
